// extracted by mini-css-extract-plugin
module.exports = {"container":"BannerHero_container__LDcLo","bulletBanner":"BannerHero_bulletBanner__FXp4q","heroSwiper":"BannerHero_heroSwiper__OhQKq","skeleton":"BannerHero_skeleton__ZOqZT"};